// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"067959e1","111":"99d63d31","359":"70999e08","448":"5c8d7e93","616":"46421281","936":"219f1697"}[chunkId] + ".js";
};